'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getHistory } from '@/history';

import s from '../styles.scss';

export default connect(
	(state, props) => ({
	}),
	{}
)(
	({ user, urlParams, pageId }) => {

		const history = getHistory();

		return (
			<a
				className={ s.link }
				onClick={
					e => {
						e.preventDefault();
						localStorage.removeItem('user');
						window.location.replace('/logout');
					}
				}
			>
				<FontAwesomeIcon icon='sign-out-alt' color='#444'/>
			</a>
		);
	}
);
